// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a731ec05","239":"b5f3aa29","455":"c1f917de"}[chunkId] + ".chunk.js";
};